import { useTranslation } from 'react-i18next'

import { ComboBox, Text } from '@reveni-io/reveni-ui'

import { customerContactMethodsOptions } from './constants'
import * as Styles from './styles'

const CustomerContactMethod = ({ customerContactMethod, onChangeCustomerContactMethod }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleS">{t('Contacto para clientes')}</Text>
      <Text type="bodyMRegular">
        {t(
          'Selecciona el método que quieres mostrar en el portal para que los clientes se pongan en contacto con la tienda.'
        )}
      </Text>
      <ComboBox
        label={t('Método de contacto para clientes')}
        menuItems={customerContactMethodsOptions.map(o => ({ ...o, label: t(o.label) }))}
        fullWidth
        value={customerContactMethod}
        handleChange={e => onChangeCustomerContactMethod(e.target.value)}
      />
    </Styles.Container>
  )
}

export default CustomerContactMethod
